import type { RequestConfig } from '@customTypes/index';
import type { WorkItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistCurrentContractRequest = {
  profileId: string;
};

export type ArtistCurrentContractParams =
  RequestConfig<ArtistCurrentContractRequest>;

export const artistCurrentContract = async ({
  params,
  config
}: ArtistCurrentContractParams) =>
  api.get<WorkItemDto>(
    `/api/work/items/current-work/${params.profileId}`,
    config
  );
